import { render, staticRenderFns } from "./commonTag.vue?vue&type=template&id=031bf7a4&scoped=true&"
import script from "./commonTag.vue?vue&type=script&lang=js&"
export * from "./commonTag.vue?vue&type=script&lang=js&"
import style0 from "./commonTag.vue?vue&type=style&index=0&id=031bf7a4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031bf7a4",
  null
  
)

export default component.exports